/* Modulo: Product Picks — variant select + add to cart on a scroll rail.

   The cart engine mirrors modulo-section-product-shelf.js. Keep the hard-won
   parts: the r.ok gate (fetch does NOT reject on 422), the CARD-level in-flight
   flag, the drawer probe that covers Horizon's `open` property setter, the
   re-query after a graft, and routes.root for subfolder markets.

   The buy row is a real <form>, so with JavaScript disabled it posts natively
   and Shopify redirects to the cart — this script only upgrades that to an
   ajax add. What is new here is the rail: flanking arrows and a progress
   thumb, both direction-aware. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  /* Markets: never hardcode '/cart'. window.Shopify.routes.root is the only
     value documented as always ending in a '/'. On a Nordic subfolder market
     it is '/en-se/', and a literal path throws away the shopper's currency —
     invisible on a US primary market, which is exactly why it ships. */
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* fetch does NOT reject on 422. Without this gate, .then(r => r.json())
     parses Shopify's error body happily and a failed add reports success. */
  function thenJson(r) {
    if (r.ok) return r.json();
    return r.text().then(function (t) {
      var body = null;
      try { body = JSON.parse(t); } catch (e) { /* not JSON; fall through */ }
      var reason = (body && (body.description || body.message)) ||
                   (t && t.slice(0, 140)) ||
                   r.statusText ||
                   'Could not add to cart';
      var err = new Error(reason);
      err.status = r.status;
      throw err;
    });
  }

  var DRAWER_QS = ['cart-drawer', 'cart-drawer-component', 'cart-notification', '[is="cart-drawer"]', '[data-cart-drawer]'];
  function findDrawer() {
    for (var i = 0; i < DRAWER_QS.length; i++) {
      var d = document.querySelector(DRAWER_QS[i]);
      if (d) return d;
    }
    return null;
  }

  /* Ask for the theme's own cart sections so the header count actually
     updates. Without this the drawer opens STALE, which is worse than not
     opening it at all. */
  function sectionList(drawer) {
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        var names = drawer.getSectionsToRender()
          .map(function (s) { return s.section || s.id; })
          .filter(Boolean);
        if (names.length) return names.join(',');
      } catch (e) { /* fall through to the generic list */ }
    }
    return 'cart-drawer,cart-icon-bubble,cart-notification,cart-live-region-text,cart-drawer-component';
  }

  /* Returns a LIVE drawer node. Dawn's <cart-drawer> owns its own rendering,
     so prefer renderContents. Otherwise graft — but the graft replaces the
     children of #shopify-section-cart-drawer, which DESTROYS the node the
     caller holds, so it must re-query. Opening the detached original is a
     silent no-op: the drawer never appears and, on themes that scroll-lock
     from the open handler, the page can lock behind nothing. */
  function refreshCart(drawer, data) {
    if (!data || !data.sections) return drawer;
    if (drawer && typeof drawer.renderContents === 'function') {
      try {
        drawer.renderContents(data);
        return drawer;
      } catch (e) { /* fall through to the graft */ }
    }
    graftSections(data);
    return findDrawer();
  }

  function graftSections(data) {
    if (!data || !data.sections) return;
    for (var key in data.sections) {
      if (!Object.prototype.hasOwnProperty.call(data.sections, key)) continue;
      var id = 'shopify-section-' + key;
      var target = document.getElementById(id);
      var html = data.sections[key];
      if (!target || !html) continue;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('#' + id);
      if (!parsed) continue;
      while (target.firstChild) target.removeChild(target.firstChild);
      while (parsed.firstChild) target.appendChild(parsed.firstChild);
    }
  }

  /* Themes vary wildly. Modern Dawn exposes .open(); some forks .openDrawer();
     Horizon exposes `open` as a PROPERTY setter (which a typeof === 'function'
     check silently skips); older Dawn/Brooklyn use a <details> open attribute. */
  function openDrawer(drawer) {
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    if (typeof drawer.show === 'function') { try { drawer.show(); return; } catch (e) {} }
    if (typeof drawer.openDrawer === 'function') { try { drawer.openDrawer(); return; } catch (e) {} }
    if ('open' in drawer && typeof drawer.open !== 'function') { try { drawer.open = true; return; } catch (e) {} }
    if (drawer.tagName === 'DETAILS') { drawer.setAttribute('open', ''); return; }
    drawer.classList.add('active', 'is-active', 'open', 'is-open');
    drawer.setAttribute('aria-hidden', 'false');
  }

  /* The real label is stashed on first use and never re-read from the DOM. The
     card's busy flag is released as soon as the request settles, but the flash
     runs for another ~1.8s — so a second click lands mid-flash. Reading
     textContent again there would capture "Added" as the original, and the
     button would read "Added" forever. */
  function flash(button, text, ms, announce) {
    var label = button.querySelector('.modulo-ppk__atc-label');
    if (!label) return;
    if (!button.dataset.ppkLabel) button.dataset.ppkLabel = label.textContent;
    var original = button.dataset.ppkLabel;
    if (button.ppkTimer) clearTimeout(button.ppkTimer);
    label.textContent = text;

    /* A textContent swap on the button the shopper is standing on is not
       reliably announced as an accessible-name change. Mirror every flash —
       success AND error — into the section's live region. `announce` is the
       UNTRUNCATED reason: the label is clipped to fit a card-width button and
       lands mid-word, but a live region has no width to run out of.
       textContent, never innerHTML: this is Shopify's own error text. */
    var sectionEl = button.closest('[data-modulo-ppk]');
    var live = sectionEl && sectionEl.querySelector('[data-modulo-ppk-live]');
    if (live) live.textContent = announce || text;

    button.ppkTimer = setTimeout(function () {
      label.textContent = original;
      button.classList.remove('is-added');
      /* Cleared with the label: a stale "Added" left in the region gets
         re-read on the next unrelated focus change. */
      if (live) live.textContent = '';
      button.ppkTimer = null;
    }, ms);
  }

  /* The in-flight flag lives on the CARD, not the button — a per-button flag
     cannot see a sibling. Serializing here also keeps us clear of the HTTP 409
     Shopify returns for simultaneous cart requests. */
  function claim(card) {
    if (!card || card.dataset.ppkBusy === '1') return false;
    card.dataset.ppkBusy = '1';
    return true;
  }
  function release(card) {
    if (card) card.dataset.ppkBusy = '0';
  }

  /* ─── Variant picker ───
     Every string comes pre-rendered from Liquid. This never formats money: a
     theme's own formatMoney is hostile (Ella throws on a one-arg call), and
     Intl would ignore the shop's money format entirely. */
  function syncVariant(card) {
    var select = card.querySelector('[data-ppk-select]');
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    if (!opt) return;

    var priceEl = card.querySelector('[data-ppk-price]');
    if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;

    var wasEl = card.querySelector('[data-ppk-was]');
    if (wasEl) {
      if (opt.dataset.compare) {
        wasEl.textContent = opt.dataset.compare;
        wasEl.hidden = false;
      } else {
        wasEl.textContent = '';
        wasEl.hidden = true;
      }
    }

    /* ─── Quantity follows the variant.
       Both controls exist on every card now, so the quantity list has to
       re-open when the shopper switches to a variant with more stock and
       close when they switch to one with less. The full 1..N list is always
       in the DOM and Liquid ships the out-of-stock tail `disabled hidden` for
       the variant the card opened on; this is the same edit applied to the
       one they just chose. Rebuilding the list instead would throw away the
       server-rendered no-JS state for no gain.

       `disabled` AND `hidden`: hidden is what removes the option from the
       menu, disabled is what stops a theme script or an autofill from
       selecting it anyway.

       The clamp DOWN is the load-bearing half. Picking 8 of a variant with 10
       and then switching to one with 2 left would otherwise post a quantity
       Shopify rejects — a 422 the shopper cannot see the cause of, on a
       button that looked like it worked. */
    var qtySelect = card.querySelector('[data-ppk-qty]');
    if (qtySelect) {
      var qtyMax = parseInt(opt.dataset.qtyMax, 10);
      if (!(qtyMax > 0)) qtyMax = qtySelect.options.length;
      for (var q = 0; q < qtySelect.options.length; q++) {
        var beyond = (q + 1) > qtyMax;
        qtySelect.options[q].disabled = beyond;
        qtySelect.options[q].hidden = beyond;
      }
      if (qtySelect.selectedIndex + 1 > qtyMax) qtySelect.selectedIndex = qtyMax - 1;
    }

    /* A disabled <option> cannot normally be selected, so this only fires if a
       theme script or an extension selects one programmatically. Cheap
       insurance against a shopper adding an unavailable variant. */
    var button = card.querySelector('[data-ppk-add]');
    if (button) {
      var available = opt.dataset.available !== '0';
      button.disabled = !available;
      var label = button.querySelector('.modulo-ppk__atc-label');
      if (label && !button.ppkTimer) {
        var soldLabel = button.getAttribute('data-sold-label') || 'Sold out';
        if (!button.dataset.ppkLabel) button.dataset.ppkLabel = label.textContent;
        label.textContent = available ? button.dataset.ppkLabel : soldLabel;
      }
    }
  }

  function addToCart(form, button, card) {
    if (!claim(card)) return;
    var drawer = findDrawer();
    var field = form.querySelector('[name="id"]');
    var variantId = field && field.value;
    if (!variantId) { release(card); return; }

    /* Every card carries a quantity select, so the ajax body has to read it. A
       hardcoded 1 here is honoured by the native no-JS POST and silently
       dropped by this path — the worst kind of divergence, because it only
       misfires for the shoppers who DO have JavaScript, which is nearly all of
       them. parseInt of a missing field is NaN and NaN > 0 is false, so a card
       rendered with the picker turned off still adds exactly one. The clamp
       also absorbs a theme script writing junk into the field. */
    var qtyField = form.querySelector('[name="quantity"]');
    var qty = parseInt(qtyField && qtyField.value, 10);
    if (!(qty > 0)) qty = 1;

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      // X-Modulo-Internal opts out of the bundle block's in-flight fetch shim.
      // Without it a quick-add landing inside that window is answered with a
      // synthetic 200 {"items":[]} and takes the SUCCESS path on an add that
      // never happened.
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Modulo-Internal': 'product-picks' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty }],
        sections: sectionList(drawer),
        sections_url: window.location.pathname
      })
    })
      .then(thenJson)
      .then(function (data) {
        button.classList.add('is-added');
        flash(button, button.getAttribute('data-added-label') || 'Added', 1800);
        /* Re-bind: refreshCart may have replaced the node `drawer` points at. */
        var live = refreshCart(drawer, data);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        openDrawer(live);
      })
      .catch(function (err) {
        var reason = (err && err.message) ? err.message : 'Try again';
        flash(button, reason.slice(0, 28), 2600, reason);
      })
      .then(function () { release(card); });
  }

  /* ─── Rail ─── */
  function railStep(rail) {
    var card = rail.querySelector('.modulo-ppk__card');
    if (!card) return rail.clientWidth;
    var styles = window.getComputedStyle(rail);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function syncRail(sectionEl) {
    var rail = sectionEl.querySelector('[data-ppk-rail]');
    if (!rail) return;
    var prev = sectionEl.querySelector('[data-ppk-prev]');
    var next = sectionEl.querySelector('[data-ppk-next]');
    var thumb = sectionEl.querySelector('[data-ppk-thumb]');

    var max = rail.scrollWidth - rail.clientWidth;
    var fits = max <= 2;
    /* Nothing overflows -> no controls at all. The track hides via the class;
       the arrows need `hidden` restated in CSS because an author display:grid
       beats the UA [hidden] rule (the `sr` lesson). */
    sectionEl.classList.toggle('modulo-ppk--fits', fits);
    if (prev) prev.hidden = fits;
    if (next) next.hidden = fits;
    if (fits) return;

    /* Math.abs: a spec-compliant RTL scroller runs 0 -> negative, so a raw
       comparison would report "at the start" at both ends (the `bs` lesson). */
    var pos = Math.abs(rail.scrollLeft);
    if (prev) prev.disabled = pos <= 2;
    if (next) next.disabled = pos >= max - 2;

    if (thumb) {
      var visible = rail.clientWidth / rail.scrollWidth;
      var w = Math.max(visible * 100, 12);
      thumb.style.width = w + '%';
      /* Anchored with inset-inline-start, so the travel must be NEGATED in RTL
         — `translate` is not direction-aware, and without this the thumb runs
         the wrong way while the numbers look correct. */
      var rtl = window.getComputedStyle(rail).direction === 'rtl';
      var travel = (pos / max) * (100 - w);
      thumb.style.translate = (rtl ? -travel : travel) + '%';
    }
  }

  function wireRail(sectionEl) {
    var rail = sectionEl.querySelector('[data-ppk-rail]');
    if (!rail) return;
    var prev = sectionEl.querySelector('[data-ppk-prev]');
    var next = sectionEl.querySelector('[data-ppk-next]');
    var dir = window.getComputedStyle(rail).direction === 'rtl' ? -1 : 1;

    if (prev) {
      prev.addEventListener('click', function () {
        rail.scrollBy({ left: -railStep(rail) * dir, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        rail.scrollBy({ left: railStep(rail) * dir, behavior: 'smooth' });
      });
    }
    rail.addEventListener('scroll', function () { syncRail(sectionEl); });
    syncRail(sectionEl);
  }

  function initSection(sectionEl) {
    /* Per-element flag, not an IIFE-wide early return: a second instance added
       in the theme editor must still bind. */
    if (sectionEl.dataset.ppkReady === '1') return;
    sectionEl.dataset.ppkReady = '1';

    wireRail(sectionEl);

    sectionEl.addEventListener('change', function (e) {
      var select = e.target.closest('[data-ppk-select]');
      if (!select || !sectionEl.contains(select)) return;
      var card = select.closest('[data-modulo-ppk-card]');
      if (card) syncVariant(card);
    });

    /* The buy row is a real product form, so this UPGRADES a working native
       POST rather than being the only thing that makes it work. */
    sectionEl.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ppk-form]');
      if (!form || !sectionEl.contains(form)) return;
      var button = form.querySelector('[data-ppk-add]');
      if (!button || button.disabled) return;
      e.preventDefault();
      addToCart(form, button, form.closest('[data-modulo-ppk-card]'));
    });

    /* A variant may arrive pre-selected from a ?variant= URL, so reconcile the
       price with the select on first paint. */
    var cards = sectionEl.querySelectorAll('[data-modulo-ppk-card]');
    for (var i = 0; i < cards.length; i++) syncVariant(cards[i]);

    /* Webfonts land after a `defer` script and change the card metrics, which
       invalidates the measured overflow. Re-measure once they settle. */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { syncRail(sectionEl); });
    }
  }

  function bootstrap() {
    var nodes = document.querySelectorAll('[data-modulo-ppk]');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }

  /* Document-level listeners are registered ONCE. The <script> tag is emitted
     per section instance, so two rails on a page execute this IIFE twice —
     without the guard, every document listener would be double-registered. The
     guard is scoped to the listeners ONLY: per-element init stays keyed on
     dataset.ppkReady, so a second instance still binds. */
  if (!window.__moduloPpkBound) {
    window.__moduloPpkBound = true;

    /* Without this, a section added in the theme editor stays dead until a
       full page reload. */
    document.addEventListener('shopify:section:load', bootstrap);

    /* A resize can cross 1180, 860 or 480, each of which changes cards-per-view
       or the arrows' existence, and therefore whether the rail overflows. */
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var nodes = document.querySelectorAll('[data-modulo-ppk]');
        for (var i = 0; i < nodes.length; i++) syncRail(nodes[i]);
      }, 100);
    });

    /* Back-navigation restores the DOM verbatim from bfcache, busy flag
       included, which would strand every card the shopper tried. */
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var cards = document.querySelectorAll('[data-modulo-ppk-card]');
      for (var i = 0; i < cards.length; i++) cards[i].dataset.ppkBusy = '0';
    });
  }
})();
